<template>
    <div class="page">
    <ion-grid fixed>
      <form @keyup.enter="saveStation">
        <ion-row class="row-divider"></ion-row>
        <ion-row class="rectangle">
          <ion-col>
            <ion-row align-items-stretch>
              <ion-col class="col-padding">
                <ion-label class="section-head">Basic Details</ion-label>
              </ion-col>
            </ion-row>
            <ion-row align-items-stretch>
              <ion-col size="12" size-md="3" class="col-padding">
                <ion-label class="section-item" position="stacked">Station ID</ion-label>
                <div class="border-line-34 readonly margin-top-10">
                  <ion-input
                    class="form-input"
                    type="number"
                    @input="id = $event.target.value"
                    :value="id"
                    readonly="true"
                  ></ion-input>
                </div>
              </ion-col>
              <ion-col size="12" size-md="3" class="col-padding">
                <ion-label class="section-item" position="stacked">
                  Station Name
                  <span class="required">*</span>
                </ion-label>
                <div class="border-line-34 margin-top-10" :class="displayInd == true ? 'readonly' : ''">
                  <ion-input
                    class="form-input"
                    type="text"
                    placeholder
                    @input="name = $event.target.value"
                    :value="name"
                    maxlength="50"
                    :readonly = displayInd
                  ></ion-input>
                </div>
              </ion-col>
              <ion-col size="12" size-md="3" class="col-padding">
                <ion-label class="section-item" position="stacked">
                  Effective From
                  <!-- <span class="required">*</span> -->
                </ion-label>
                <div class="date-picker-box margin-top-10 datepicker-web" :class="displayInd == true ? 'readonly' : ''">
                  <datepicker
                    class="form-vue-picker"
                    placeholder="DD/MON/YYYY"
                    inputFormat="dd/MMM/yyyy"
                    v-model="effectiveOn"
                    :typeable="true"
                    :disabled = "displayInd == true ? 'true' : false"
                  ></datepicker>
                  <span class="custom-calendar-icon">
                    <img src="/../assets/images/common/datepicker/calendar.png" />
                  </span>
                </div>
                <div class="border-line-34 margin-top-10 datepicker-mobile">
                  <!-- <div class="input-icon-calendar"> -->
                    <!-- <ion-datetime
                      class="form-picker"
                      placeholder="Select Date"
                      displayFormat="YYYY, MM, DD"
                      @ionChange="effectiveOn = $event.target.value"
                      :value="effectiveOn"
                      :disabled = "displayInd == true ? 'true' : false"
                    ></ion-datetime> -->
                    <datepicker 
                      v-model="effectiveOn" 
                      class="form-picker"  
                      inputFormat="MMM dd, yyyy"
                      placeholder="Select Date"
                      :readonly="true"
                      :disabled = "displayInd == true ? 'true' : false"
                    />
                    <span class="input-icon-calendar">
                      <img src="/../assets/images/common/datepicker/calendar.png" />
                    </span>
                  <!-- </div> -->
                </div>
              </ion-col>
              <ion-col size="12" size-md="3" class="col-padding">
                <ion-label class="section-item" position="stacked">
                  Last Effective Date
                  <!-- <span class="required">*</span> -->
                </ion-label>
                <div class="date-picker-box margin-top-10 datepicker-web">
                  <datepicker
                    class="form-vue-picker"
                    placeholder="DD/MON/YYYY"
                    inputFormat="dd/MMM/yyyy"
                    v-model="effectiveTill"
                    :typeable="true"
                    :disabled = "displayInd == true ? 'true' : false"
                  ></datepicker>
                  <span class="custom-calendar-icon">
                    <img src="/../assets/images/common/datepicker/calendar.png" />
                  </span>
                </div>
                <div class="border-line-34 margin-top-10 datepicker-mobile">
                  <!-- <div class="input-icon-calendar"> -->
                    <!-- <ion-datetime
                      class="form-picker"
                      placeholder="Select Date"
                      displayFormat="YYYY, MM, DD"
                      @ionChange="effectiveTill = $event.target.value"
                      :value="effectiveTill"
                      :disabled = "displayInd == true ? 'true' : false"
                    ></ion-datetime> -->
                    <datepicker 
                      v-model="effectiveTill" 
                      class="form-picker"  
                      inputFormat="MMM dd, yyyy"
                      placeholder="Select Date"
                      :readonly="true"
                      :disabled = "displayInd == true ? 'true' : false"
                    />
                    <span class="input-icon-calendar">
                      <img src="/../assets/images/common/datepicker/calendar.png" />
                    </span>
                  <!-- </div> -->
                </div>
              </ion-col>
              <ion-col size="12" size-md="3" class="col-padding">
                <ion-label class="section-item" position="stacked">
                  Distribution Node
                  <!-- Below code is commented by vinoth on 30.04.2021 as per new requirements -->
                  <!-- <span class="required">*</span> -->
                </ion-label>
                <div class="border-line-34 margin-top-10" :class="displayInd == true ? 'readonly' : ''">
                  <ion-input
                    class="form-input"
                    type="text"
                    placeholder
                    @input="distributionNode = $event.target.value"
                    :value="distributionNode"
                    maxlength="100"
                  ></ion-input>
                </div>
              </ion-col>
              <ion-col size="12" size-md="3" class="col-padding">
                <ion-label class="section-item" position="stacked">
                  Status
                  <span class="required">*</span>
                </ion-label>
                <div class="border-line-34 margin-top-10" >
                  <ion-select
                    class="form-select select-mobile"
                    :value="status"
                    @ionChange="status = $event.target.value"
                    placeholder="Select Status"
                    interface="action-sheet"
                    :disabled = "displayInd == true ? 'true' : false"
                  >
                    <ion-select-option
                      v-for="(status, index) in this.statuses"
                      :key="index"
                      :value="status.id"
                    >{{status.name}}</ion-select-option>
                  </ion-select>

                  <select
                    class="input-select select-web"
                    v-model="status"
                    placeholder="Select State"
                    :disabled = "displayInd == true ? 'true' : false"
                  >
                    <option
                      v-for="(status, index) in this.statuses"
                      :key="index"
                      :value="status.id"
                    >{{status.name}}</option>
                  </select>
                </div>
              </ion-col>
              <!-- New Req as per EVDMS -->
              <ion-col size="12" size-md="3" class="col-padding">
                <!-- <ion-label class="section-item" position="stacked">
                  Visible To All
                  <span class="required">*</span>
                </ion-label> -->
                <ion-label class="section-item" position="stacked">
                  Captive
                  <span class="required">*</span>
                </ion-label>
                <div class="border-line-34 margin-top-10">
                  <ion-select
                    class="form-select select-mobile"
                    :value="visibleToAll"
                    @ionChange="visibleToAll = $event.target.value"
                    placeholder="Select visible Status"
                    interface="action-sheet"
                    :disabled = "displayInd == true ? 'true' : false"
                  >
                    <ion-select-option
                      v-for="(status, index) in this.stationVisibilityStatus"
                      :key="index"
                      :value="status.id"
                    >{{status.name}}</ion-select-option>
                  </ion-select>

                  <select
                    class="input-select select-web"
                    v-model="visibleToAll"
                    placeholder="Select visible status"
                    :disabled = "displayInd == true ? 'true' : false"
                  >
                    <option
                      v-for="(status, index) in this.stationVisibilityStatus"
                      :key="index"
                      :value="status.id"
                    >{{status.name}}</option>
                  </select>
                </div>
              </ion-col>
              <!-- New Req as per EVDMS -->
              <ion-col size="12" size-md="3" class="col-padding">
                <ion-label class="section-item" position="stacked">
                  Third Party Status
                  <span class="required">*</span>
                </ion-label>
                <div class="border-line-34 margin-top-10">
                  <ion-select
                    class="form-select select-mobile"
                    :value="thirdPartyStatus"
                    @ionChange="changeThirdPartyStatus($event.target.value)"
                    placeholder="Select visible Status"
                    interface="action-sheet"
                    :disabled = "displayInd == true ? 'true' : false"
                  >
                    <ion-select-option
                      v-for="(status, index) in this.thirdPartyStationStatus"
                      :key="index"
                      :value="status.id"
                    >{{status.name}}</ion-select-option>
                  </ion-select>

                  <select
                    class="input-select select-web"
                    v-model="thirdPartyStatus"
                    placeholder="Select visible status"
                    :disabled = "displayInd == true ? 'true' : false"
                  >
                    <option
                      v-for="(status, index) in this.thirdPartyStationStatus"
                      :key="index"
                      :value="status.id"
                    >{{status.name}}</option>
                  </select>
                </div>
              </ion-col>
              
              <ion-col size="12" size-md="3" class="col-padding" v-if="thirdPartyStationList.length != 0">
                <ion-label class="section-item" position="stacked">
                  Third Party Stations List
                  <span class="required">*</span>
                </ion-label>
                <div class="border-line-34 margin-top-10">
                  <ion-select
                    class="form-select select-mobile"
                    :value="thirdPartyId"
                    @ionChange="thirdPartyId = $event.target.value"
                    placeholder="Select visible Status"
                    interface="action-sheet"
                    :disabled = "displayInd == true ? 'true' : false"
                  >
                    <ion-select-option
                      v-for="(thirdParty, index) in this.thirdPartyStationList"
                      :key="index"
                      :value="thirdParty.id"
                    >{{thirdParty.name}}</ion-select-option>
                  </ion-select>

                  <select
                    class="input-select select-web"
                    v-model="thirdPartyId"
                    placeholder="Select visible status"
                    :disabled = "displayInd == true ? 'true' : false"
                  >
                    <option
                      v-for="(thirdParty, index) in this.thirdPartyStationList"
                      :key="index"
                      :value="thirdParty.id"
                    >{{thirdParty.name}}</option>
                  </select>
                </div>
              </ion-col>
              <!-- <ion-col size="12" size-md="3" class="col-padding">
                <ion-label class="section-item" position="stacked">Description</ion-label>
                <div class="border-line-34 readonly margin-top-10">
                  <ion-input
                    class="form-input"
                    type="number"
                    @input="id = $event.target.value"
                    :value="id"
                    readonly="true"
                  ></ion-input>
                </div>
              </ion-col> -->
            </ion-row>
            <hr />
            <ion-row align-items-stretch>
              <ion-col class="col-padding">
                <ion-label class="section-head">Location Details</ion-label>
              </ion-col>
            </ion-row>
            <ion-row align-items-stretch>
              <ion-col size="12" size-md="3" class="col-padding">
                <ion-label class="section-item" position="stacked">
                  Building Name
                  <span class="required">*</span>
                </ion-label>
                <div class="border-line-34 margin-top-10">
                  <ion-input
                    class="form-input"
                    type="text"
                    placeholder
                    @input="line1 = $event.target.value"
                    :value="line1"
                    maxlength="100"
                    :readonly = "displayInd == true ? 'true' : false"
                  ></ion-input>
                </div>
              </ion-col>
              <ion-col size="12" size-md="3" class="col-padding">
                <ion-label class="section-item" position="stacked">
                  Street Address
                  <span class="required">*</span>
                </ion-label>
                <div class="border-line-34 margin-top-10">
                  <ion-input
                    class="form-input"
                    type="text"
                    placeholder
                    @input="line2 = $event.target.value"
                    :value="line2"
                    maxlength="100"
                    :readonly = "displayInd == true ? 'true' : false"
                  ></ion-input>
                </div>
              </ion-col>
              <ion-col size="12" size-md="3" class="col-padding">
                <ion-label class="section-item" position="stacked">
                  Area Name
                  <span class="required">*</span>
                </ion-label>
                <div class="border-line-34 margin-top-10">
                  <ion-input
                    class="form-input"
                    type="text"
                    placeholder
                    @input="line3= $event.target.value"
                    :value="line3"
                    maxlength="100"
                    :readonly = "displayInd == true ? 'true' : false"
                  ></ion-input>
                </div>
              </ion-col>
              <ion-col size="12" size-md="3" class="col-padding">
                <ion-label class="section-item" position="stacked">
                  Landmark
                  <!-- <span class="required">*</span> -->
                </ion-label>
                <div class="border-line-34 margin-top-10">
                  <ion-input
                    class="form-input"
                    type="text"
                    placeholder
                    @input="landmark = $event.target.value"
                    :value="landmark"
                    maxlength="100"
                    :readonly = "displayInd == true ? 'true' : false"
                  ></ion-input>
                </div>
              </ion-col>
              <ion-col size="12" size-md="3" class="col-padding">
                <ion-label class="section-item" position="stacked">
                  City
                  <span class="required">*</span>
                </ion-label>
                <div class="border-line-34 margin-top-10">
                  <ion-input
                    class="form-input"
                    type="text"
                    placeholder
                    @input="city = $event.target.value"
                    :value="city"
                    maxlength="100"
                    :readonly = "displayInd == true ? 'true' : false"
                  ></ion-input>
                </div>
              </ion-col>
              <ion-col size="12" size-md="3" class="col-padding">
                <ion-label class="section-item" position="stacked">
                  State
                  <span class="required">*</span>
                </ion-label>
                <div class="border-line-34 margin-top-10">
                  <ion-select
                    class="form-select select-mobile"
                    :value="state"
                    @ionChange="setValueToState($event.target.value)"
                    placeholder="Select State"
                    interface="action-sheet"
                    :disabled = "displayInd == true ? 'true' : false"
                  >
                    <ion-select-option
                      v-for="(state, index) in this.states"
                      :key="index"
                      :value="state.code"
                    >{{state.name}}</ion-select-option>
                  </ion-select>

                  <select
                    class="input-select select-web"
                    v-model="state"
                    placeholder="Select State"
                    @change="setValueToState($event.target.value)"
                    :disabled = "displayInd == true ? 'true' : false"
                  >
                    <option
                      v-for="(state, index) in this.states"
                      :key="index"
                      :value="state.code"
                    >{{ state.name }}</option>
                  </select>
                </div>
              </ion-col>
              <ion-col size="12" size-md="3" class="col-padding">
                <ion-label class="section-item" position="stacked">
                  Pincode
                  <span class="required">*</span>
                </ion-label>
                <div class="border-line-34 margin-top-10">
                  <ion-input
                    class="form-input"
                    type="text"
                    @input="zipcode = $event.target.value"
                    :value="zipcode"
                    maxlength="6"
                    :readonly = "displayInd == true ? 'true' : false"
                  ></ion-input>
                </div>
              </ion-col>
              <ion-col size="12" size-md="3" class="ion-no-margin col-nopadding">
                <ion-row align-items-stretch class="ion-no-margin col-nopadding">
                  <ion-col size="12" size-md="6" class="col-nopadding">
                    <ion-label class="section-item" position="stacked">
                      Latitute
                      <span class="required">*</span>
                    </ion-label>
                    <div class="border-line-34 margin-top-10">
                      <ion-input
                        class="form-input"
                        type="number"
                        placeholder
                        @input="latitude = $event.target.value"
                        :value="latitude"
                        maxlength="10"
                        min="0"
                        :readonly = "displayInd == true ? 'true' : false"
                      ></ion-input>
                    </div>
                  </ion-col>
                  <ion-col size="12" size-md="6" class="col-nopadding">
                    <ion-label class="section-item" position="stacked">
                      Longitute
                      <span class="required">*</span>
                    </ion-label>
                    <div class="border-line-34 margin-top-10">
                      <ion-input
                        class="form-input"
                        type="number"
                        placeholder
                        @input="longitude = $event.target.value"
                        :value="longitude"
                        maxlength="10"
                        min="0"
                        :readonly = "displayInd == true ? 'true' : false"
                      ></ion-input>
                    </div>
                  </ion-col>
                </ion-row>
              </ion-col>
            </ion-row>
            <hr />
            <ion-row align-items-stretch>
              <ion-col class="col-padding">
                <ion-label class="section-head">Contact Info</ion-label>
              </ion-col>
            </ion-row>
            <ion-row align-items-stretch>
              <ion-col size="12" size-md="3" class="col-padding">
                <ion-label class="section-item" position="stacked">
                  Telephone
                  <span class="required">*</span>
                </ion-label>
                <div class="border-line-34 margin-top-10">
                  <ion-input
                    class="form-input"
                    type="tel"
                    placeholder
                    @input="landline = $event.target.value"
                    :value="landline"
                    minlength="7"
                    maxlength="15"
                    :readonly = "displayInd == true ? 'true' : false"
                  ></ion-input>
                </div>
              </ion-col>
              <ion-col size="12" size-md="3" class="col-padding">
                <ion-label class="section-item" position="stacked">
                  Mobile
                  <span class="required">*</span>
                </ion-label>
                <div class="border-line-34 margin-top-10">
                  <ion-input
                    class="form-input"
                    type="tel"
                    placeholder
                    @input="mobile = $event.target.value"
                    :value="mobile"
                    maxlength="10"
                    :readonly = "displayInd == true ? 'true' : false"
                  ></ion-input>
                </div>
              </ion-col>
              <ion-col size="12" size-md="3" class="col-padding">
                <ion-label class="section-item" position="stacked">
                  Email
                  <span class="required">*</span>
                </ion-label>
                <div class="border-line-34 margin-top-10">
                  <ion-input
                    class="form-input"
                    type="email"
                    placeholder
                    @input="email = $event.target.value"
                    :value="email"
                    maxlength="200"
                    :readonly = "displayInd == true ? 'true' : false"
                  ></ion-input>
                </div>
              </ion-col>
            </ion-row>
            <hr />
            <ion-row align-items-stretch>
              <ion-col class="col-padding">
                <ion-label class="section-head">Associated Branch</ion-label>
              </ion-col>
            </ion-row>
            <ion-row align-items-stretch>
              <ion-col size="12" size-md="3" class="col-padding">
                <ion-label class="section-item" position="stacked">
                  Corporate Name
                  <span class="required">*</span>
                </ion-label>
                <div class="border-line-box-34 margin-top-10"  @click="openBranchModal">
                    <ion-input
                      class="form-input"
                      type="text"
                      id="corporateName"
                      placeholder="Enter Corporate Name"
                      @input="corporateName = $event.target.value"
                      :value="corporateName"
                      readonly="true"
                      
                    ></ion-input>
                    <span class="input-search-icon">
                      <img src="/../assets/images/common/search/116836.png" />
                    </span>
                  </div>
              </ion-col>
              <ion-col size="12" size-md="3" class="col-padding">
                <ion-label class="section-item" position="stacked">
                  Branch Name
                  <span class="required">*</span>
                </ion-label>
                <div class="border-line-box-34 margin-top-10"  @click="openBranchModal">
                    <ion-input
                      class="form-input"
                      type="text"
                      id="branchName"
                      placeholder="Enter Branch Name"
                      @input="branchName = $event.target.value"
                      :value="branchName"
                      readonly="true"
                    ></ion-input>
                    <span class="input-search-icon">
                      <img src="/../assets/images/common/search/116836.png" />
                    </span>
                  </div>
              </ion-col>
              <ion-col size="12" size-md="3" class="col-padding">
                <br />
                <ion-button class="btn-clear margin-top-10" @click="clearFields" :disabled = "displayInd == true ? 'true' : false">
                <ion-icon :icon= "refresh"></ion-icon>
              </ion-button>
              </ion-col>
            </ion-row>
            <hr />
            <!-- Holiday details and working ui changed and added by vinoth kumar -->
            <!--  v-if="index!=7" added in three column because need to hide holiday column 18.12.2020  -->
        <div>
              <ion-grid>
                <ion-row>
                  <ion-col size="10">
                    <ion-label class="section-head">Working Hours</ion-label>
                  </ion-col>
                  <ion-col size="2" class="ion-text-right">
                    <ion-icon :icon= workingIconName @click="expandWorkingDetails"></ion-icon>
                  </ion-col>
                </ion-row>
                <div v-if="displayWorkingDetailDiv">
                  <ion-row align-items-stretch>
                    <ion-col size="12" size-md="3" class="col-padding"></ion-col>
                    <ion-col size="12" size-md="3" class="col-padding">
                      <ion-label class="section-item" position="stacked">Opening Time</ion-label>
                    </ion-col>
                    <ion-col size="12" size-md="3" class="col-padding">
                      <ion-label class="section-item" position="stacked">Closing Time</ion-label>
                    </ion-col>
                  </ion-row>
                  <ion-row class="row-divider"></ion-row>
                  <ion-row class="row-divider"></ion-row>

                  <ion-row
                    align-items-stretch
                    v-for="(workHours, index) in this.workingHours"
                    :key="index"
                  >
                    <ion-col size="12" size-md="3" class="col-padding" v-if="index!=7">
                      <ion-label
                        class="section-item"
                        position="stacked"
                      >{{workingDays[workHours.weekDay]}}</ion-label>
                    </ion-col>
                    <!--  v-if="index != 7" added because need to hide holiday column 18.12.2020 -->
                    <ion-col size="12" size-md="3" class="col-padding"  v-if="index!=7">
                      <div class="border-line-34">
                        <ion-input
                          class="form-input"
                          type="time"
                          placeholder
                          @input="workHours.opensAt = $event.target.value"
                          :value="workHours.opensAt"
                          maxlength="8"
                        ></ion-input>
                        <!-- <div class="input-icon-datetime">
                  <ion-datetime
                    class="form-picker"
                    placeholder="Select Time"
                    display-format="HH:mm"
                    picker-format="HH:mm"
                    @ionChange="workHours.opensAt = $event.target.value"
                    :value="workHours.opensAt"
                  ></ion-datetime>
                        </div>-->
                      </div>
                    </ion-col>
                    <ion-col size="12" size-md="3" class="col-padding" v-if="index!=7">
                      <div class="border-line-34">
                        <ion-input
                          class="form-input"
                          type="time"
                          placeholder
                          @input="workHours.closesAt = $event.target.value"
                          :value="workHours.closesAt"
                          maxlength="8"
                        ></ion-input>
                        <!-- <div class="input-icon-datetime">
                  <ion-datetime
                    class="form-picker"
                    placeholder="Select Time"
                    display-format="HH:mm"
                    picker-format="HH:mm"
                    @ionChange="workHours.closesAt = $event.target.value"
                    :value="workHours.closesAt"
                  ></ion-datetime>
                        </div>-->
                      </div>
                    </ion-col>
                    <ion-col size="12" size-md="3" class="col-padding">
                      <ion-label
                        class="section-item"
                      >{{getTimeInfo(workHours.opensAt, workHours.closesAt)}}</ion-label>
                    </ion-col>
                  </ion-row>
                </div>
              </ion-grid>
            </div>
            
            <hr />
            <div>
              <ion-grid>
                <ion-row>
                  <ion-col size="10">
                    <ion-label class="section-head">Holiday Details</ion-label>
                  </ion-col>
                  
                  <ion-col size="2" class="ion-text-right">
                    <ion-icon :icon= holidayIconName @click="expandHolidayDetails"></ion-icon>
                  </ion-col>
                </ion-row>
              </ion-grid>
              <ion-grid v-if="displayHolidayDetails && state && !loaderTab"> 
                <ion-row>
                  <ion-col v-for="item in holidayWorkingColumn" v-bind:key="item" class="ion-text-left">
                    <ion-label class="section-item" position="stacked">{{item}}</ion-label>
                  </ion-col>
                </ion-row>
                <div v-if="this.holidayList.length > 0 ">
                <ion-row v-for="holiday of holidayList" :key="holiday"  class="ion-text-left">
                  <ion-col class="border-line-holiday-34"><ion-label class="section-item" position="stacked" @click="editHoliday(holiday,'editHoliday')"><ion-icon :icon="create" class="create-trash-icon customIcon"></ion-icon></ion-label></ion-col>
                  <ion-col class="border-line-holiday-34"><ion-label class="section-item" position="stacked" @click="deleteHoliday(holiday)"><ion-icon :icon="trash" class="create-trash-icon customIcon"></ion-icon></ion-label></ion-col>
                  <!-- <ion-col class="border-line-holiday-34"><ion-label class="section-item" position="stacked">{{changeDateFormatWithoutTime(holiday.date)}}</ion-label></ion-col> -->
                  <ion-col class="border-line-holiday-34"><ion-label class="section-item ion-no-padding" position="stacked">{{holiday.year}}</ion-label></ion-col>
                  <ion-col class="border-line-holiday-34"><ion-label class="section-item ion-no-padding" position="stacked">{{holiday.holidayName}}</ion-label></ion-col>
                  <ion-col class="border-line-holiday-34"><ion-label class="section-item" position="stacked" v-if="holiday.startTime != '00:00:00'">{{holiday.startTime}}</ion-label></ion-col>
                  <ion-col class="border-line-holiday-34"><ion-label class="section-item" position="stacked" v-if="holiday.endTime != '00:00:00'">{{holiday.endTime}}</ion-label></ion-col>
                  <ion-col class="border-line-holiday-34"><ion-label class="section-item" position="stacked">{{getStatus(holiday)}}</ion-label></ion-col>
                </ion-row>
                </div>
                <ion-row>
                  <ion-col>
                    <ion-button class="customButton" size="small" @click="editHoliday('','holiday')">Add Holiday<ion-icon v-slot: icon-only :icon= "add"></ion-icon></ion-button>
                  </ion-col>
                </ion-row>
                <br/>
              </ion-grid>
            </div>
            <hr />
            
          </ion-col>
        </ion-row>

        <ion-row align-items-stretch>
          <ion-col size="12" class="col-nopadding ion-text-right">
            <ion-button class="btn-primary" @click="cancel">Cancel</ion-button>
            <ion-button class="btn-primary" @click="saveStation">Save</ion-button>
          </ion-col>
        </ion-row>
      </form>
    </ion-grid>
    <div class="spinner">
      <ion-spinner v-if="loaderTab"></ion-spinner>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import { IonButton, IonCol, IonGrid, IonIcon, IonInput, IonLabel, IonRow, IonSelect, IonSelectOption, IonSpinner, modalController, alertController } from "@ionic/vue";
import { refresh, add, create, trash } from 'ionicons/icons';
import moment from "moment";
// import { AuthenticationService } from "../../service/account/authenticator.service";
import { LocationService } from "../../service/location/location.service";
import { EVCStationService } from "../../service/evcstation/stations.service";
import { LocalStorage } from "../../data/localstorage";
// import { Credential } from "../../entity/authentication/credential";
import { Address } from "../../entity/location/address";
import { State } from "../../entity/location/state";
import { EVCStation, EVCStationStatus, EVCStationVisibiltyStatus, EVCStationThirdPartyStatus, EVCStationThirdPartyList } from "../../entity/location/evcstation";
import { Coordiate } from "../../entity/location/corodinate";
// import { HoursOfOperation, Time } from "../../entity/hours-of-operation";

import { ValidationUtils } from "../../util/validation-utils";
import { ToastUtils } from "../../util/toast-utils";
import { AlertUtils } from "../../util/alert-utils";
import { AppUtils } from "../../util/app-utils";
// import Datepicker from "vuejs-datepicker/dist/vuejs-datepicker.esm.js";
import datepicker from 'vue3-datepicker';
import { tryParseServiceError, migratedTryParseServiceError } from "../../service";
import { chevronDown, chevronForward } from 'ionicons/icons';
import  HolidayEditAdd  from '../admin/HolidayEditAdd.vue';
import { HolidayService } from '@/service/holiday/holiday.service';
import StationBranchModel from "../corporate/StationBranchModel.vue";

import { EVStationBranch } from "../../entity/corporate/corporateDetails";

export default defineComponent ({
  name: 'chargingStationDetail',
  components: {
    datepicker, IonGrid, IonRow, IonCol, IonLabel, IonInput, IonSelect, IonSelectOption, IonButton, IonIcon, IonSpinner, modalController, alertController
  },
  data() {
    return {
      trash,
      create,
      refresh,
      add,
      loaderTab: true,
      mode: "ADD",
      stationId: "",
      states: [],
      stateModels: [],
      statuses: [],
      statusModels: [],
      workingHours: [],
      workingDays: new AppUtils().getWorkingDays(),
      id: "",
      name: "",
      effectiveOn: "",
      effectiveTill: "", //new Date(9999, 11, 31),
      status: "",
      line1: "",
      line2: "",
      line3: "",
      landmark: "",
      city: "",
      state: "",
      zipcode: "",
      latitude: "",
      longitude: "",
      mobile: "",
      email: "",
      landline: "",
      distributionNode: "",
      displayHolidayDetails: false,
      displayWorkingDetailDiv : false,
      holidayIconName: chevronForward,
      workingIconName: chevronForward,
      holidayWorkingColumn: ['Edit', 'Delete','Date', 'Year', 'Holiday Name', 'Start Time', 'End Time', 'Status'],
      holidayList: [],
      editedHolidayList: [],
      branchInfo: "",
      corporateName: "",
      branchName: "",
      corporateId: "",
      branchId: "",
      branchStatus: "",
      stationVisibilityStatus: [],
      thirdPartyStationStatus: [],
      thirdPartyStationList: [],
      thirdPartyId: "",
      visibleToAll: "Y",
      thirdPartyStatus: "N",
      userRole: "",
      displayInd: false
    }
  },
  async mounted() {
    this.userRole = localStorage.getItem("user.roleId")
    if(this.userRole == 4) {
      this.displayInd = true
    }
    try {
      this.states = await new LocationService().states();
      this.statuses = await new EVCStationService().stationStatuses();
      this.workingHours = new EVCStationService().stationOperationHours();
      this.stationVisibilityStatus = await new EVCStationService().stationVisibleStatuses();
      this.thirdPartyStationStatus = await new EVCStationService().thirdPartyStationStatus();
    } catch(error) {
      this.loaderTab = false;
      let serviceError = migratedTryParseServiceError(error);
      new ToastUtils().presentToast(serviceError.description);
    }
   
    this.statusModels = [];
    this.statuses.forEach(status => {
    this.statusModels.push({
        text: status.name,
        value: status.id
    });
    });

    this.stateModels = [];
    this.states.forEach(state => {
      this.stateModels.push({
          text: state.name,
          value: state.code
      });
    });
    if (this.$route.params.stationId) {
      await new EVCStationService().stationWithId(this.$route.params.stationId).then((station) => {
        this.fillStation(station);
      }).catch((error) => {
        this.loaderTab = false;
        let serviceError = migratedTryParseServiceError(error);
        new ToastUtils().presentToast(serviceError.description);
      });
      
    }
    this.loaderTab = false;
  },
  methods: {
    changeDateFormatWithoutTime(dateValue) {  
      if(dateValue != null || dateValue != undefined) {
          return moment(dateValue).format('DD/MMM/YYYY')
      }
    },
    clearFields() {
      this.corporateName = "";
      this.branchName = "";
      this.branchId = "";
      this.corporateId = "";
      document.getElementById('corporateName').value = null;
      document.getElementById('branchName').value = null;
    },
    //new column added 4-12-2020 holiday working details added by vinothkumar
    expandWorkingDetails() {
      if (!this.displayWorkingDetailDiv) {
          this.displayWorkingDetailDiv = true;
          this.workingIconName = chevronDown;
      } else {
          this.displayWorkingDetailDiv = false;
          this.workingIconName = chevronForward;
      }
    },
    expandHolidayDetails() {
      if (!this.displayHolidayDetails) {
          this.displayHolidayDetails = true;
          this.holidayIconName = chevronDown
      } else {
          this.displayHolidayDetails = false;
          this.holidayIconName = chevronForward
      }
    },
    editHoliday: async function(holiday, NewOrEdit) {
      try {
        let typeOfHoliday;
        if(NewOrEdit == 'editHoliday') {
        typeOfHoliday = 'Edit Holiday'
        } else {
        typeOfHoliday = 'Add Holiday'
        }
        const modal = await modalController.create({
        // let modal =  await this.$ionic.modalController.create({
          component: HolidayEditAdd,
          componentProps: {
            propsData: {
              selectedHolidayData: holiday,
              holidayType: typeOfHoliday,
              stationId: this.stationId,
              stationName: this.name,
              state: this.state,
              startTime: holiday.startTime != '00:00:00' ? holiday.startTime : '',
              endTime: holiday.endTime != '00:00:00' ? holiday.endTime : '',
              fullDayInd: holiday.fulldayHoliday
            },
              
          },
          backdropDismiss: false,
          cssClass: 'modal-design'
        });
        modal.componentProps = {
          selectedHolidayData: holiday,
          holidayType: typeOfHoliday,
          stationId: this.stationId,
          stationName: this.name,
          state: this.state,
          startTime: holiday.startTime != '00:00:00' ? holiday.startTime : '',
          endTime: holiday.endTime != '00:00:00' ? holiday.endTime : '',
          fullDayInd: holiday.fulldayHoliday
        }
        await modal.present();
        let formResponseData = await modal.onDidDismiss();
        if(formResponseData.data != '') {
          this.holidayList = [];
          this.holidayList = formResponseData.data;
          if(typeOfHoliday == 'Edit Holiday') {
              new ToastUtils().presentToast('Holiday modified successfully');
          } else {
              new ToastUtils().presentToast('Holiday added successfully');
          }
        }
      } catch(error) {
        // new ToastUtils().presentToast(error.response.data.errors[0].detail);
        let serviceError = migratedTryParseServiceError(error);
        new ToastUtils().presentToast(serviceError.description);
      }
    },

    async deleteHoliday(holidayData) {
      return alertController.create({
        header: 'Do you want to delete?',
        message: holidayData.holidayName + "\n"+moment(holidayData.date).format('DD MMM, YYYY'),
        buttons: [
          {
            text: 'Cancel',
            role: 'cancel',
            handler: res => {
            // console.log(res);
            }
          },
          {
            text: 'Delete',
            handler: async () => {
              let data = {
                stationId: this.stationId,
                stationHolidayId: holidayData.stationHolidayId,
                date: holidayData.date,
                year: holidayData.year,
                state: holidayData.state
              }
              // let afterDeletedData = await new HolidayService().deleteHoliday(data);
              // if(afterDeletedData.length != 0) {
              //   this.holidayList = [];
              //   this.holidayList = afterDeletedData;
              //   new ToastUtils().presentToast("Holiday deleted successfully");
              // } else {
              //   this.holidayList = [];
              //   new ToastUtils().presentToast("Holiday deleted successfully");
              // }
              await new HolidayService().deleteHoliday(data).then((afterDeletedData) => {
                if(afterDeletedData.length != 0) {
                  this.holidayList = [];
                  this.holidayList = afterDeletedData;
                  new ToastUtils().presentToast("Holiday deleted successfully");
                } else {
                  this.holidayList = [];
                  new ToastUtils().presentToast("Holiday deleted successfully");
                }
              }).catch((error) => {
                let serviceError = migratedTryParseServiceError(error);
                new ToastUtils().presentToast(serviceError.description);
              })
            }
          } 
        ]
      }).then(res => res.present());      
    },
    async setValueToState(selectedState) {
      this.holidayList = [];
      this.state = selectedState;
      let data = {
        state : this.state,
        stationId: this.stationId
      }
      // let holidayFromDb = await new HolidayService().getHolidayList(
      // {
      //   state : this.state,
      //   stationId: this.stationId}
      //   );
      // if(holidayFromDb.length > 0) {
      //   this.holidayList = holidayFromDb;
      // }
      await new HolidayService().getHolidayList({ state : this.state, stationId: this.stationId}).then((holidayFromDb) => {
        if(holidayFromDb.length > 0) {
          this.holidayList = holidayFromDb;
        }
      }).catch((error) => {
        let serviceError = migratedTryParseServiceError(error);
        new ToastUtils().presentToast(serviceError.description);
      })
    },
    getStatus(holiday) {
      if(holiday.startTime === undefined || holiday.startTime === '' || holiday.startTime === '00:00:00' 
      || holiday.endTime === undefined || holiday.endTime === '' || holiday.endTime === '00:00:00' ) {
          return "Active";
      } else {
          return "Active";
      }
    },
    async changeThirdPartyStatus(status) {
      this.loaderTab = true;
      this.thirdPartyStatus = status
      if(this.thirdPartyStatus == 'Y') {
          // this.thirdPartyStationList = await new EVCStationService().thirdPartyStationList();
          await new EVCStationService().thirdPartyStationList().then((thirdPartyStationList) => {
            this.loaderTab = false;
            this.thirdPartyStationList = thirdPartyStationList;
          }).catch((error) => {
            this.loaderTab = false;
            let serviceError = migratedTryParseServiceError(error);
            new ToastUtils().presentToast(serviceError.description);
          })
      } else {
        this.loaderTab = false;
        this.thirdPartyStationList = [];
        this.thirdPartyId = null;
      }
    },
    fillStation(station) {
      this.mode = "UPDATE";
      this.stationId = station.id;
      this.id = station.id;
      this.name = station.name;
      this.effectiveOn = station.effectiveOn;
      this.effectiveTill = station.effectiveTill;
      this.status = station.status.id;
      this.visibleToAll = station.visibilityStatus.id;
      this.thirdPartyStatus = station.thirdPartyStatus.id;
      this.thirdPartyId = station.thirdPartyInfo != undefined ? station.thirdPartyInfo.id : "";
      this.line1 = station.address.line1;
      this.line2 = station.address.line2;
      this.line3 = station.address.line3;
      this.landmark = station.address.landmark;
      this.city = station.address.city;
      this.state = station.address.state.code;
      this.setValueToState(this.state)
      this.zipcode = station.address.zipcode;
      this.latitude = station.coordinate.latitude;
      this.longitude = station.coordinate.longitude;
      this.mobile = station.mobile;
      this.email = station.email;
      this.landline = station.landline;
      this.workingHours = station.hoursOfOperations;
      this.distributionNode = station.distributionNode;
      this.corporateName = station.branch.corporateName;
      this.branchName = station.branch.branchName;
      this.corporateId = station.branch.corporateId;
      this.branchId = station.branch.branchId;
    },
    getTimeInfo(opensAt, closesAt) {
      var retval = "";
      var beginningTime = moment(opensAt, "HH:mm");
      var endTime = moment(closesAt, "HH:mm");
      if (endTime.isBefore(beginningTime)) {
          retval = "(Next day)";
      }
      return retval;
    },
    cancel() {
      this.$router.back();
    },
    async saveStation() {
      try {
        this.loaderTab = true;
          if (
          typeof this.name === "undefined" ||
          this.name === null ||
          this.name === "" ||
          this.name.trim().length === 0
          ) {
          new ToastUtils().presentToast("Enter Charger Station Name");
          }
          else if (
          typeof this.status === "undefined" ||
          this.status === null ||
          this.status === ""
          ) {
          new ToastUtils().presentToast("Select Status");
          } else if(this.thirdPartyStatus == 'Y' && this.thirdPartyId == "") {
          new ToastUtils().presentToast("Select Third Party");
          } else if (
          typeof this.line1 === "undefined" ||
          this.line1 === null ||
          this.line1 === "" ||
          this.line1.trim().length === 0
          ) {
          new ToastUtils().presentToast("Enter Building Name");
          } else if (
          typeof this.line2 === "undefined" ||
          this.line2 === null ||
          this.line2 === "" ||
          this.line2.trim().length === 0
          ) {
          new ToastUtils().presentToast("Enter Street Address");
          } else if (
          typeof this.line3 === "undefined" ||
          this.line3 === null ||
          this.line3 === "" ||
          this.line3.trim().length === 0
          ) {
          new ToastUtils().presentToast("Enter Area Name");
          } else if (
          typeof this.city === "undefined" ||
          this.city === null ||
          this.city === "" ||
          this.city.trim().length === 0
          ) {
          new ToastUtils().presentToast("Enter City");
          } else if (
          typeof this.state === "undefined" ||
          this.state === null ||
          this.state === ""
          ) {
          new ToastUtils().presentToast("Select State");
          } else if (
          typeof this.zipcode === "undefined" ||
          this.zipcode === null ||
          this.zipcode === "" ||
          this.zipcode.trim().length === 0
          ) {
          new ToastUtils().presentToast("Enter Pincode");
          } else if (
          typeof this.latitude === "undefined" ||
          this.latitude === null ||
          this.latitude === "" ||
          this.latitude.trim().length === 0
          ) {
          new ToastUtils().presentToast("Enter Latitute");
          } else if (
          new ValidationUtils().positiveNumber(this.latitude) === false
          ) {
          new ToastUtils().presentToast("Enter Valid Latitute");
          } else if (
          typeof this.longitude === "undefined" ||
          this.longitude === null ||
          this.longitude === "" ||
          this.longitude.trim().length === 0
          ) {
          new ToastUtils().presentToast("Enter Longitute");
          } else if (
          new ValidationUtils().positiveNumber(this.longitude) === false
          ) {
          new ToastUtils().presentToast("Enter Valid Longitute");
          } else if (
          typeof this.landline === "undefined" ||
          this.landline === null ||
          this.landline === "" ||
          this.landline.trim().length === 0
          ) {
          new ToastUtils().presentToast("Enter Telephone Number");
          } else if (new ValidationUtils().telephone(this.landline) === false) {
          new ToastUtils().presentToast("Enter Valid Telephone Number");
          } else if (
          typeof this.mobile === "undefined" ||
          this.mobile === null ||
          this.mobile === "" ||
          this.mobile.trim().length === 0
          ) {
          new ToastUtils().presentToast("Enter Mobile Number");
          } else if (new ValidationUtils().mobile(this.mobile) === false) {
          new ToastUtils().presentToast("Enter Valid Mobile Number");
          } else if (
          typeof this.email === "undefined" ||
          this.email === null ||
          this.email === "" ||
          this.email.trim().length === 0
          ) {
          new ToastUtils().presentToast("Enter Email Address");
          } else if (new ValidationUtils().email(this.email) === false) {
          new ToastUtils().presentToast("Enter Valid Email Address");
          }  
          else {
          let station = null;
          if (this.mode == "ADD") {
            if(this.status == "A" && (this.corporateName == "" || this.corporateName == undefined || this.corporateName == null || this.corporateName.trim().length === 0 ) && (this.branchName == "" || this.branchName == undefined || this.branchName == null || this.branchName.trim().length === 0 )) {
              new ToastUtils().presentToast("Please Associate a Branch to the Station");
              } else {
                try {
                  station = await new EVCStationService().createEVCStationByAuthor(
                    new EVCStation(
                    this.id,
                    this.name,
                    this.effectiveOn ? new Date(this.effectiveOn) : null,
                    this.effectiveTill ? new Date(this.effectiveTill) : null,
                    new EVCStationStatus(this.status),
                    new EVCStationVisibiltyStatus(this.visibleToAll),
                    new EVCStationThirdPartyStatus(this.thirdPartyStatus),
                    new EVCStationThirdPartyList(this.thirdPartyId, "", "", ""),
                    new Address(
                        this.line1,
                        this.line2,
                        this.line3,
                        this.landmark,
                        this.city,
                        new State(this.state),
                        this.zipcode
                    ),
                    this.landline,
                    this.mobile,
                    this.email,
                    new Coordiate(this.latitude, this.longitude),
                    this.workingHours,
                    this.distributionNode,
                    "",
                    "",
                    new EVStationBranch((this.corporateId) ? this.corporateId : "", (this.corporateName) ? this.corporateName : "", (this.branchId) ? this.branchId : "", (this.branchName) ? this.branchName : "", this.branchStatus)
                    ),
                    new LocalStorage().user
                );
                new ToastUtils().presentToast("Charging Station saved successfully");
                this.$router.back();
              } catch(error) {
                this.loaderTab = false;
                let serviceError = migratedTryParseServiceError(error);
                new ToastUtils().presentToast(serviceError.description);
              } 
            }
          } else {
            try {
              if(this.status == "A" && (this.corporateName == "" || this.corporateName == undefined || this.corporateName == null || this.corporateName.trim().length === 0 ) && (this.branchName == "" || this.branchName == undefined || this.branchName == null || this.branchName.trim().length === 0 )) {
                await new ToastUtils().presentToast("Please Associate a Branch to the Station")
              } else {
                station = await new EVCStationService().updateEVCStationByAuthor(
                    new EVCStation(
                    this.id,
                    this.name,
                    this.effectiveOn ? new Date(this.effectiveOn) : null,
                    this.effectiveTill ? new Date(this.effectiveTill) : null,
                    new EVCStationStatus(this.status),
                    new EVCStationVisibiltyStatus(this.visibleToAll),
                    new EVCStationThirdPartyStatus(this.thirdPartyStatus),
                    new EVCStationThirdPartyList(this.thirdPartyId, "", "", ""),
                    new Address(
                        this.line1,
                        this.line2,
                        this.line3,
                        this.landmark,
                        this.city,
                        new State(this.state),
                        this.zipcode
                    ),
                    this.landline,
                    this.mobile,
                    this.email,
                    new Coordiate(this.latitude, this.longitude),
                    this.workingHours,
                    this.distributionNode,
                    "",
                    "",
                    new EVStationBranch((this.corporateId) ? this.corporateId : "", (this.corporateName) ? this.corporateName : "", (this.branchId) ? this.branchId : "", (this.branchName) ? this.branchName : "", this.branchStatus)
                    ),
                    new LocalStorage().user
                );
                new ToastUtils().presentToast("Charging Station saved successfully");
                this.$router.back();
              }
            } catch(error) {
              this.loaderTab = false;
              let serviceError = migratedTryParseServiceError(error);
              new ToastUtils().presentToast(serviceError.description);
            } 
            
          }
        }
          // new ToastUtils().presentToast("Charging Station saved successfully");
          //       this.$router.back();
      } catch (error) {
        this.loaderTab = false;
          // let serviceError = tryParseServiceError(error);
          // new AlertUtils().presentAlert(serviceError ? serviceError : error);
          // new ToastUtils().presentToast(error.response.data.errors[0].detail);
        let serviceError = migratedTryParseServiceError(error);
        new ToastUtils().presentToast(serviceError.description);
      }
    },

    async openBranchModal() {
      if(!this.displayInd) { 
        const modal = await modalController.create({
        // let modal = await this.$ionic.modalController.create({
        component: StationBranchModel,
        componentProps: {
          methods: {
            viewBranch(branchInfo) {
              
              modal.dismiss(branchInfo);
            }
          }
        },
        // cssClass: "modal-fullscreen"
        });
        modal.cssClass = "modal-fullscreen"
        modal.onDidDismiss().then(data => {
          if(data.role != 'backdrop') {
            if(data.data != '') {
              this.branchInfo = data["data"]; // Here's your selected user!
              this.corporateName = this.branchInfo.corporateName;
              this.branchName = this.branchInfo.branch;
              this.branchId = this.branchInfo.branchId;
              this.corporateId = this.branchInfo.corporateId;
              this.branchStatus = this.branchInfo.status;
            }
          }
        
        
        });
        return await modal.present();
      }
    },
  }
})
</script>

<style scoped>
.readonly {
  background: #f8f8f8 0% 0% no-repeat padding-box;
}
.customIcon{
  font-size: 1.7rem;
}
.customButton {
  --background: #12d449 !important;
}
.modal-fullscreen {
  position: absolute;
  display: block;
  width: 100%;
  height: 100%;
  overflow: scroll;
}
</style>